import { SelectMode } from '../../../../field-settings/settings-shared/options/options-list/types';
export function getSelectMode(_temp) {
  let {
    maxItems,
    products
  } = _temp === void 0 ? {} : _temp;
  if (maxItems === 1) {
    return SelectMode.onlyOne;
  }
  if (products != null && products.length && products.every(product => {
    var _product$quantityLimi;
    return typeof ((_product$quantityLimi = product.quantityLimit) == null ? void 0 : _product$quantityLimi.maximum) === 'undefined';
  })) {
    return SelectMode.many;
  }
  return SelectMode.oneByOne;
}
//# sourceMappingURL=get-select-mode.js.map